import React from 'react';
import { Phone, Mail, Instagram } from 'lucide-react';
import { Button } from './ui/button';

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Skontaktuj Się</h2>
          <p className="section-description">
            Gotowy na zmianę? Skontaktuj się ze mną i rozpocznij swoją transformację już dziś!
          </p>
        </div>
        <div className="contact-content">
          <div className="contact-card">
            <div className="contact-item">
              <div className="contact-icon">
                <Phone size={32} />
              </div>
              <div className="contact-details">
                <h3 className="contact-label">Telefon</h3>
                <a href="tel:+48668904145" className="contact-link">
                  +48 668 904 145
                </a>
                <Button 
                  className="btn-contact"
                  onClick={() => window.location.href = 'tel:+48668904145'}
                >
                  Zadzwoń Teraz
                </Button>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <Mail size={32} />
              </div>
              <div className="contact-details">
                <h3 className="contact-label">Email</h3>
                <a href="mailto:pawel.kozlowski.1989@o2.pl" className="contact-link">
                  pawel.kozlowski.1989@o2.pl
                </a>
                <Button 
                  className="btn-contact"
                  onClick={() => window.location.href = 'mailto:pawel.kozlowski.1989@o2.pl'}
                >
                  Wyślij Email
                </Button>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <Instagram size={32} />
              </div>
              <div className="contact-details">
                <h3 className="contact-label">Social Media</h3>
                <a 
                  href="https://www.instagram.com/trener.kozlowski.89" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  @trener.kozlowski.89
                </a>
                <a 
                  href="https://www.tiktok.com/@Dragon1989" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  @Dragon1989 (TikTok)
                </a>
                <Button 
                  className="btn-contact"
                  onClick={() => window.open('https://www.instagram.com/trener.kozlowski.89', '_blank')}
                >
                  Obserwuj na Instagram
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
